import React, { Component } from 'react'
import { Popup as SPopup } from 'semantic-ui-react'

class Popup extends Component {
  state = {
    open: false,
    clicked: false
  }

  handleOpen = (event, data) => {
    const { onOpen, notShowOnClick } = this.props
    const { type } = event
    this.setState(({ clicked }) => ({
      clicked: type === 'click',
      // On responsive, make a click dispatch first the click event and
      // then the mouseover event
      open: notShowOnClick ? !(type === 'click' || clicked) : true
    }))
    if (onOpen) {
      onOpen(event, data)
    }
  }

  handleClose = (event, data) => {
    const { onClose } = this.props
    this.setState({ open: false })
    if (onClose) {
      onClose(event, data)
    }
  }

  render() {
    const { open } = this.state
    const { trigger, content, children, notShowOnClick, className, ...props } =
      this.props

    return (
      <SPopup
        open={open}
        trigger={
          // Div required when the trigger is disabled
          <div className={className}>{trigger}</div>
        }
        size='tiny'
        position='top center'
        inverted
        basic
        {...props}
        onOpen={this.handleOpen}
        onClose={this.handleClose}
      >
        {content || children}
      </SPopup>
    )
  }
}

export default Popup
